import { render, staticRenderFns } from "./ModalPeopleInfo.vue?vue&type=template&id=41336acc&"
import script from "./ModalPeopleInfo.vue?vue&type=script&lang=js&"
export * from "./ModalPeopleInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModalPeopleInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports